import React from 'react'

const Navbar = () => {
  return (
    <div className='navContainer flex_std'>
        <h1>Quiz app</h1>
    </div>
  )
}

export default Navbar;